import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLanguage: localStorage.getItem("selectedLanguage")
    ? JSON.parse(localStorage.getItem("selectedLanguage"))
    : 1,
};

const languageSlice = createSlice({
  name: "languageSlice",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
      localStorage.setItem("selectedLanguage", action.payload);
      return state;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice;